(() => {
  const INTRO_ID = 'zo-home-intro';
  const PLAY_DURATION = 3000;
  const qaPreview = new URLSearchParams(window.location.search).has('zo_intro_live');
  const INTRO_DURATION = window.location.pathname.includes('zo-home-intro-preview') || qaPreview ? 8000 : PLAY_DURATION;

  function runIntro() {
    const intro = document.getElementById(INTRO_ID);
    if (!intro) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const closeButton = intro.querySelector('[data-zo-home-intro-close]');
    let closeTimer;
    let isClosed = false;

    function closeIntro() {
      if (isClosed) return;
      isClosed = true;
      window.clearTimeout(closeTimer);
      document.documentElement.classList.remove('zo-home-intro-active');
      intro.classList.remove('is-open');
      intro.classList.add('is-leaving');

      window.setTimeout(() => {
        intro.hidden = true;
        intro.classList.remove('is-leaving');
      }, 300);
    }

    intro.hidden = false;
    intro.style.setProperty('--zo-intro-duration', `${PLAY_DURATION}ms`);
    document.documentElement.classList.add('zo-home-intro-active');
    window.requestAnimationFrame(() => intro.classList.add('is-open'));

    closeButton?.addEventListener('click', closeIntro, { once: true });
    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape') closeIntro();
      },
      { once: true }
    );
    const reducedDuration = qaPreview || window.location.pathname.includes('zo-home-intro-preview') ? INTRO_DURATION : 1500;
    closeTimer = window.setTimeout(closeIntro, reduceMotion.matches ? reducedDuration : INTRO_DURATION);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runIntro, { once: true });
  } else {
    runIntro();
  }
})();
